export const updateItems = `mutation($model : UpdateItemsRequest!){
    updateItems(input : $model) {
        kmatID
        modVer
        itemID
        partDescription
        filterCondition
        defaultCondition
        counterCvg
        cvg
        defaultComponents
        messages
        img_info
        comments
        obsoleteOn
        isManual
        isTemplate
        tabCategory
      }
  }`
